/**
 * Bootstrap modals enforce focus inside `.modal`, which breaks Zone overlays teleported to
 * `#zone-teleport` (search fields lose focus — same reason select2 uses `dropdownParent` in
 * forms.js). Register once per modal so Select and other Zone overlays can keep using
 * `#zone-teleport` without a component-specific portal target.
 *
 * @param {Element | null | undefined} modalElement
 */
export function allowZoneTeleportFocusInLegacyModal(modalElement) {
  if (!modalElement || modalElement.dataset.zoneTeleportFocusBound === 'true') {
    return;
  }

  modalElement.dataset.zoneTeleportFocusBound = 'true';

  const focusInCapture = (event) => {
    if (!modalElement.classList.contains('show')) {
      return;
    }

    const zoneTeleport = document.getElementById('zone-teleport');

    if (!zoneTeleport?.contains(event.target)) {
      return;
    }

    event.stopImmediatePropagation();
  };

  document.addEventListener('focusin', focusInCapture, true);

  modalElement.addEventListener('hidden.bs.modal', () => {
    document.removeEventListener('focusin', focusInCapture, true);
    delete modalElement.dataset.zoneTeleportFocusBound;
  });
}
